/**
 * Created by richard on 7/17/14.
 */
var taxSettingAffectedFamiliesModel = angular.module('taxSettingAffectedFamiliesModel', ['schoolModel']);
taxSettingAffectedFamiliesModel.factory('TaxSettingAffectedFamiliesModelFactory', function(SchoolModelFactory){
    var taxSettingAffectedFamiliesModel = function(){
        this.endpoint = '/TaxSettingAffectedFamilies';
        this.primaryKey = '';

    }
    taxSettingAffectedFamiliesModel.prototype = new SchoolModelFactory();
    taxSettingAffectedFamiliesModel.prototype.parent = SchoolModelFactory.prototype;

    return taxSettingAffectedFamiliesModel;
});


taxSettingAffectedFamiliesModel.service('TaxSettingAffectedFamiliesModelService', function(TaxSettingAffectedFamiliesModelFactory){
    return new TaxSettingAffectedFamiliesModelFactory();
});


